import Logger from './utils/logger';
import Foreman from './models/foreman';

((_w) => {
  Logger.debug('Initializing...');

  const foreman = new Foreman();

  foreman.init(_w);
})(window);



// WEBPACK FOOTER //
// ./src/brick-layer.js